import { inject } from "@angular/core";
import {
  Router,
  type CanActivateFn,
  type RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(["/login"], {
    queryParams: { returnUrl: state.url },
  });
};
